import { render, staticRenderFns } from "./ReminderDialog2.vue?vue&type=template&id=60773cf8&scoped=true"
import script from "./ReminderDialog2.vue?vue&type=script&lang=js"
export * from "./ReminderDialog2.vue?vue&type=script&lang=js"
import style0 from "./ReminderDialog2.vue?vue&type=style&index=0&id=60773cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60773cf8",
  null
  
)

export default component.exports